import { render, staticRenderFns } from "./FrequentUsers.vue?vue&type=template&id=a7af1380"
import script from "./FrequentUsers.vue?vue&type=script&lang=js"
export * from "./FrequentUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports